import styled from "styled-components/macro";
import { theme } from "ui/theme";
import Modal from "ui/Modal";
import Typography from "ui/Typography";
import OrangeTealShapeBanner from "images/shapeBanner_orange_teal.png";
import WhiteRip from "images/rip_white.png";
import { ReactComponent as LightBulb } from "images/lightBulb_illustration.svg";
import Inline from "ui/Inline";
import longRipAsset from "images/longRip.png";
import Form from "ui/Form";
import { $ContentContainer } from "ui/CollapsibleContainer/styled-components";

const MODAL_PADDING = "2.5rem";

export const $ModalDialog = styled(Modal.Dialog)`
  @media screen and (${theme.BreakpointPhoneUp}) {
    max-width: 34rem;
  }

  .modal-content {
    padding: ${MODAL_PADDING} 0 0;
    background-image: url(${OrangeTealShapeBanner});
    background-size: contain;
    background-repeat: no-repeat;
    border: none;
  }
`;

export const $ArticlesContainer = styled.div`
  background-image: url(${WhiteRip});
  background-position: center top;
  margin-top: 1.5rem;
  padding: 3rem ${MODAL_PADDING} 2.5rem;
`;

export const $ArticlesHeading = styled(Typography)`
  padding: 2rem 0 1.5rem;
`;

export const $HelpCenterText = styled(Typography).attrs({
  fontStyle: "italic",
})`
  padding-left: 2.25rem;
  margin-top: 0.5rem;
`;

export const $IntegrationResourcesText = styled(Typography)`
  margin-top: 1.5rem;
  white-space: nowrap;
`;

export const $FormContainer = styled.div`
  width: 100%;
  padding-bottom: 1.5rem;
`;

const ADDITIONAL_HELP_CONTAINER_TOP_PADDING = "5rem";

export const $AdditionalHelpContainer = styled.div`
  padding: ${ADDITIONAL_HELP_CONTAINER_TOP_PADDING} ${MODAL_PADDING} 0;
  background: linear-gradient(
    to bottom,
    transparent ${ADDITIONAL_HELP_CONTAINER_TOP_PADDING},
    ${({ theme }) => theme.ColorSneaker100}
      ${ADDITIONAL_HELP_CONTAINER_TOP_PADDING}
  );
  position: relative;

  &::before {
    content: "";
    width: 100%;
    height: ${ADDITIONAL_HELP_CONTAINER_TOP_PADDING};
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(${longRipAsset});
  }

  @media screen and (max-width: 60.5rem) {
    ${$ContentContainer} {
      max-width: initial;
    }
  }
`;

export const $LightBulb = styled(LightBulb)`
  color: ${({ theme }) => theme.ColorSun500};
  flex-shrink: 0;
`;

export const $Inline = styled(Inline)`
  margin-bottom: 0.8rem;
`;

export const $AdditionalHelpHeading = styled(Typography).attrs({
  size: "h4",
  forwardedAs: "h2",
  textAlign: "center",
})`
  margin-bottom: ${({ theme }) => theme.SizeXs};
`;

export const $FormInput = styled(Form.Control)`
  border: 1px solid ${({ theme }) => theme.ColorSpace500};
  color: ${({ theme }) => theme.ColorSpace500};
`;

export const $FormSelect = styled($FormInput).attrs({
  forwardedAs: "select",
})``;

export const $FormTextarea = styled($FormInput).attrs({
  forwardedAs: "textarea",
})``;

export const $SuccessMessageContainer = styled.div`
  text-align: center;
  padding-bottom: 3rem;
`;

export const $SuccessMessageHeading = styled(Typography).attrs({
  size: "h3",
  forwardedAs: "h5",
})`
  margin: ${({ theme }) => theme.SizeMd} 0;
`;
